export default {
  CREATE: `Create a break`,
  CREATE_RULE: `Create a break rule`,
  DELETE_BUTTON: {
    TITLE: `Delete the break`,
    SUMMARY: `Are you sure you want to delete this break?`,
    PRIMARY_ACTION: `Delete the break`
  },
  DELETE_BUTTON_RULES: {
    TITLE: `Delete the break rule`,
    SUMMARY: `This will permanently remove the break rule, it will not be possible to recover it.`,
    PRIMARY_ACTION: `Delete the break rule`
  },
  LIST: {
    TITLE: `Break list`,
    SUMMARY: ``
  },
  LIST_RULES: {
    TITLE: `Break rules list`,
    SUMMARY: ``
  },
  DURATION: `Duration`,
  PAID: `Paid`,
  PREVENTPUNCHING: `Prevent punching`,
  BREAKS: `Breaks`,
  THRESHOLD: `Threshold`,
  form: {
    CREATE: {
      TITLE: `Creating break`,
      SUMMARY: ``
    },
    CREATE_RULE: {
      TITLE: `Creating break rule`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Editing break`,
      SUMMARY: ``
    },
    EDIT_RULE: {
      TITLE: `Editing break rule`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Break name`,
      DESCRIPTION: `This name should help you quickly identify the break.`,
      PLACEHOLDER: `Enter a name for the break`
    },
    DURATION: {
      LABEL: `Break duration`,
      DESCRIPTION: `The duration must be entered in minutes.`,
      PLACEHOLDER: `Enter a duration for the break`
    },
    PAID: {
      LABEL: `Paid`,
      DESCRIPTION: `Paid breaks count towards hours, whereas unpaid breaks are deducted from time worked.`
    },
    PREVENTPUNCHING: {
      LABEL: `Prevent punching`,
      DESCRIPTION: `Employees won't be able to punch in and out of this break.`
    },
    NAME_REQUIRED: `Break's name is mandatory.`,
    INVALID_BREAK_DURATION: `The entered break duration is invalid, it must be between 1 and 300.`,
    DURATION_REQUIRED: `Break's duration is mandatory.`,
    AUTOASSIGN: {
      LABEL: `Automatic assignment`,
      OPTIONS: {
        NONE: { LABEL: `Do not auto-assign`, DESCRIPTION: `` },
        THRESHOLD: { LABEL: `Minimum threshold`, DESCRIPTION: `` },
        SCHEDULED_TIME: { LABEL: `Scheduled start`, DESCRIPTION: `` }
      }
    },
    THRESHOLD: {
      LABEL: `Shift length`,
      DESCRIPTION: `This break will be added to shifts at least this many minutes long.`,
      PLACEHOLDER: `Enter a length`
    },
    SCHEDULEDTIME: {
      LABEL: `Scheduled time`,
      DESCRIPTION: `This break will be added at a specific time, end time will be based on start time and duration.`,
      PLACEHOLDER: `Enter a time`
    },
    DEPARTMENTS: {
      LABEL: `Department`,
      DESCRIPTION: `Department of the position`
    }
  },
  rulesForm: {
    NAME: {
      LABEL: `Break rule name`,
      DESCRIPTION: `This name should allow you to quickly identify the break rule.`,
      PLACEHOLDER: `Enter a name for the break`
    },
    THRESHOLD: {
      LABEL: `Minimum threshold`,
      DESCRIPTION: `This threshold represents the minimum length of a shift that this break rule applies to. It will apply until the minimum threshold of another break rule is passed`,
      PLACEHOLDER: `Enter the wanted threshold`
    },
    BREAKS_PLACEHOLDER: `Enter the amount of breaks to add`,
    AMOUNT_OF_BREAK: `Break amount`,
    BREAKS_TO_ADD: `Type of breaks to add and their amount`,
    NAME_REQUIRED: `Break rule's name is mandatory.`,
    INVALID_BREAK_THRESHOLD: `The break rule threshold is invalid, it must be between 1 and 1440.`,
    THRESHOLD_REQUIRED: `The break rule threshold is mandatory.`,
    INVALID_BREAK_AMOUNT: `Invalid amount of break`,
    BREAK_AMOUNT_REQUIRED: `The break amount is mandatory. You can enter 0 for no breaks.`
  }
}
